
import { Component, OnInit, Injector, ChangeDetectionStrategy, inject } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { GenericIdbaComponent, IdbaLookupConfig } from '@i7/shared';
import { Programa } from 'src/app/models/bas/programa/programa';
import { ESSENTIALS, MATERIAL_BUTTONS, MATERIAL_FORM, MATERIAL_LAYOUT } from '@i7/shared';

@Component({
  standalone: true,
  imports: [
    ESSENTIALS,
    MATERIAL_BUTTONS,
    MATERIAL_LAYOUT,
    MATERIAL_FORM
  ],
  selector: 'app-run-modal',
  templateUrl: './run-modal.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./run-modal.component.scss']
})
export class RunModalComponent extends GenericIdbaComponent implements OnInit {

  programaLookup: IdbaLookupConfig<Programa>;

  dialogRef: MatDialogRef<RunModalComponent>;

  private injector = inject(Injector);
  private formBuilder = inject(UntypedFormBuilder);
  private router = inject(Router);


  constructor() {
    super();
    this.dialogRef = this.injector.get(MatDialogRef);
  }

  override ngOnInit(): void {
    this.createForm();
  }

  private createForm() {
    this.form = this.formBuilder.group({
      programa: [{ id: 0 },],
    });
    this.programaLookup = {
      label: 'Programa', placeholder: 'Programa',
      source: {
        kind: 'service', service: this.acessoService,
        procedure: 'pi-consulta-permissao-usuario',
        parameters: { rowid: this.authService.getLoggedUserRowid() },
      },
      idKey: 'id', display: { property: 'descricaoPrograma' },
      selection: { initialId: this.form.controls['programa'].value?.id || null },
    };
  }

  closeModal() {
    if (this.form.valid) {
      const obj = this.form.getRawValue();
      let registro = obj;

      this.router.navigate([registro.programa.siglaModulo.toLowerCase(), registro.programa.nomePrograma.toLowerCase()]);

      this.dialogRef.close();
    } else {
      this.showMessage('Campos obrigatórios não foram preenchidos.', 'Error');
    }
  }
}


